export enum FluffyAppBenefits {
  FreeDogTraining = 'Free dog training courses',
  VetAndBehaviouristSupport = 'Free 24/7 vet support',
  FoodDiscount = 'Up to 50% discount on food',
  AccessToExclusiveCommunity = 'Access to exclusive community',
  FreePersonalizedPuppyGrowthPlans = 'Free personalised puppy growth plans',
  DiscountOnPetServices = 'Up to 50% discount on pet services',
}

export function isFluffyAppBenefit(fluffyAppBenefitCandidate: string): fluffyAppBenefitCandidate is FluffyAppBenefits {
  return fluffyAppBenefitCandidate in FluffyAppBenefits;
}
